import MatreshkaArray from './index.js';
import forEach from '../_helpers/foreach.js';
// creates a new Matreshka.Array instance with a variable number of arguments,
// regardless of number or type of the arguments
export default function of() {
  for (var _len = arguments.length, _items = new Array(_len), _key = 0; _key < _len; _key++) {
    _items[_key] = arguments[_key];
  }
  // allow to inherit this method by child classes
  var ParentClass = typeof this === 'function' ? this : MatreshkaArray;
  var result = new ParentClass();
  var newItems = Array(arguments.length);
  forEach(arguments, function (item, index) {
    newItems[index] = item;
  });
  // recreate applies Model and item mediator of the class
  return result.recreate(newItems, {
    silent: true,
    dontRender: true
  });
}